/**
 * hp-media-video
 *
 * Ürün kartlarındaki ve ürün detay galerisindeki videoları GIF gibi oynatır:
 * sessiz, sonsuz döngü, kontrol yok.
 *
 * - Kaynak (src) yalnızca video görünür alana yaklaşınca atanır.
 * - Görünür alandan çıkan video duraklatılır, geri girince kaldığı yerden devam eder.
 * - data-hp-video-trigger="hover" olan videolar sadece kart hover'ında oynar.
 * - Sonradan DOM'a eklenen kartlar (infinite scroll, filtre, quick view) otomatik yakalanır.
 */
(function () {
  'use strict';

  var SELECTOR = '[data-hp-autoplay-video]';
  var ROOT_MARGIN = '300px 0px';

  var observer = null;

  function isHoverTriggered(video) {
    return video.getAttribute('data-hp-video-trigger') === 'hover';
  }

  function attachSource(video) {
    var src = video.getAttribute('data-hp-video-src');
    if (!src || video.getAttribute('src') === src) return;
    video.setAttribute('src', src);
    video.load();
  }

  function play(video) {
    attachSource(video);
    video.muted = true;
    var promise = video.play();
    if (promise && typeof promise.catch === 'function') {
      promise.catch(function () {
        /* Otomatik oynatma engellendiyse poster görseli gösterilmeye devam eder. */
      });
    }
  }

  function pause(video) {
    if (!video.paused) video.pause();
  }

  function onIntersect(entries) {
    entries.forEach(function (entry) {
      var video = entry.target;
      if (!entry.isIntersecting) {
        video.hpVisible = false;
        pause(video);
        return;
      }

      video.hpVisible = true;
      if (isHoverTriggered(video)) {
        // Hover videosu indirilmez, yalnızca fareyle üzerine gelinince yüklenir
        if (video.hpHovered) play(video);
      } else {
        play(video);
      }
    });
  }

  function bindHover(video) {
    var card = video.closest('.product-card-media') || video.parentElement;
    if (!card || card.hpHoverBound) {
      if (card) card.hpHoverBound = true;
      return;
    }
    card.hpHoverBound = true;

    card.addEventListener('mouseenter', function () {
      card.querySelectorAll('[data-hp-video-trigger="hover"]').forEach(function (item) {
        item.hpHovered = true;
        if (item.hpVisible !== false) play(item);
      });
    });

    card.addEventListener('mouseleave', function () {
      card.querySelectorAll('[data-hp-video-trigger="hover"]').forEach(function (item) {
        item.hpHovered = false;
        pause(item);
      });
    });
  }

  function register(video) {
    if (video.hpVideoBound) return;
    video.hpVideoBound = true;

    // Bazı tarayıcılar attribute'u yok sayabiliyor; property olarak da set ediyoruz.
    video.muted = true;
    video.defaultMuted = true;

    if (isHoverTriggered(video)) bindHover(video);

    if (observer) {
      observer.observe(video);
    } else if (!isHoverTriggered(video)) {
      play(video);
    }
  }

  function scan(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(SELECTOR).forEach(register);
  }

  function init() {
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(onIntersect, {
        rootMargin: ROOT_MARGIN,
        threshold: 0.01,
      });
    }

    scan(document);

    if ('MutationObserver' in window) {
      var rescanQueued = false;
      new MutationObserver(function (mutations) {
        if (rescanQueued) return;
        var hasNewElements = mutations.some(function (mutation) {
          return mutation.addedNodes.length > 0;
        });
        if (!hasNewElements) return;

        // Sayfadaki her DOM eklemesinde tarama yapmamak için tek karede topluyoruz.
        rescanQueued = true;
        window.requestAnimationFrame(function () {
          rescanQueued = false;
          scan(document);
        });
      }).observe(document.body, { childList: true, subtree: true });
    }

    // Tema içi olaylar (infinite scroll, varyant değişimi, quick view)
    ['infiniteScrollLoaded', 'shopify:section:load', 'variant:changed'].forEach(function (name) {
      document.addEventListener(name, function () {
        scan(document);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
